module.exports = __webpack_public_path__ + "static/media/coldstorage5.7bbded1d.jpg";